module.exports = __webpack_public_path__ + "img/idea_code_logo.10e2a13c.png";